/**
 * Pure helper for the caller's effective permissions at a Location: the company-wide
 * assignments unioned with the ones the caller's roles grant at that Location
 * (`UserInfoLocation.permissions`). Company-wide permissions always apply (priority) and are
 * never removed by switching Location. A null/unknown Location (or one with no location-scoped
 * permissions) falls back to the company-wide list unchanged.
 *
 * Kept as a dependency-free leaf so it can be unit-tested without importing the AuthStore graph.
 */
export const resolvePermissionsAtLocation = (
  companyWide: string[] | undefined | null,
  locations: { id: string; permissions: string[] | null }[] | undefined | null,
  locationId: string | null
): string[] => {
  const base = companyWide ?? [];
  if (!locationId) {
    return base;
  }
  const location = locations?.find(l => l.id === locationId);
  const locationPermissions = location?.permissions ?? [];
  return locationPermissions.length
    ? Array.from(new Set([...base, ...locationPermissions]))
    : base;
};
